"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERVIEW_STOP = exports.INTERVIEW_DISQUALIFIED = exports.INTERVIEW_PROGRESS_COMPLETE = exports.INTERVIEW_PROGRESS_EDIT = exports.INTERVIEW_PROGRESS_PREVIEW = exports.INTERVIEW_PROGRESS_OTHER = exports.INTERVIEW_PROGRESS_DEBTS = exports.INTERVIEW_PROGRESS_EXPENSES = exports.INTERVIEW_PROGRESS_INCOME = exports.INTERVIEW_PROGRESS_ASSETS = exports.INTERVIEW_PROGRESS_ABOUT = exports.RESTARTED = exports.UNARCHIVED = exports.ARCHIVED = exports.DEBTOR_EDITED = exports.REVIEW_FINISHED = exports.REVIEW_STARTED = exports.ASSIGNED = exports.INTERVIEW_SESSION_ENDED = exports.INTERVIEW_SESSION_PROGRESS = exports.INTERVIEW_SESSION_STARTED = exports.INTERVIEW_SESSION_INIT = exports.CLOSED = exports.DISCHARGED = exports.DISMISSED = exports.CREDITORS_MEETING_FINISHED = exports.CREDITORS_MEETING_PREP = exports.MAILED_TRUSTEE = exports.COURSE_TWO_FINISHED = exports.COURSE_TWO_STARTED = exports.FILED = exports.WILL_FILE = exports.READY_FOR_REVIEW = exports.COURSE_ONE_FINISHED = exports.COURSE_ONE_STARTED = exports.UPLOADED_SUPPLEMENTS = exports.INTERVIEW_FINISHED = exports.INTERVIEW_STARTED = exports.INTAKE = void 0; // Milestones

var INTAKE = 'intake';
exports.INTAKE = INTAKE;
var INTERVIEW_STARTED = 'interviewStarted';
exports.INTERVIEW_STARTED = INTERVIEW_STARTED;
var INTERVIEW_FINISHED = 'interviewFinished';
exports.INTERVIEW_FINISHED = INTERVIEW_FINISHED;
var UPLOADED_SUPPLEMENTS = 'uploadedSupplements';
exports.UPLOADED_SUPPLEMENTS = UPLOADED_SUPPLEMENTS;
var COURSE_ONE_STARTED = 'courseOneStarted';
exports.COURSE_ONE_STARTED = COURSE_ONE_STARTED;
var COURSE_ONE_FINISHED = 'courseOneFinished';
exports.COURSE_ONE_FINISHED = COURSE_ONE_FINISHED;
var READY_FOR_REVIEW = 'readyForReview';
exports.READY_FOR_REVIEW = READY_FOR_REVIEW;
var WILL_FILE = 'willFile';
exports.WILL_FILE = WILL_FILE;
var FILED = 'filed';
exports.FILED = FILED;
var COURSE_TWO_STARTED = 'courseTwoStarted';
exports.COURSE_TWO_STARTED = COURSE_TWO_STARTED;
var COURSE_TWO_FINISHED = 'courseTwoFinished';
exports.COURSE_TWO_FINISHED = COURSE_TWO_FINISHED;
var MAILED_TRUSTEE = 'mailedTrustee';
exports.MAILED_TRUSTEE = MAILED_TRUSTEE;
var CREDITORS_MEETING_PREP = 'creditorsMeetingPrep';
exports.CREDITORS_MEETING_PREP = CREDITORS_MEETING_PREP;
var CREDITORS_MEETING_FINISHED = 'creditorsMeetingFinished';
exports.CREDITORS_MEETING_FINISHED = CREDITORS_MEETING_FINISHED;
var DISMISSED = 'dismissed';
exports.DISMISSED = DISMISSED;
var DISCHARGED = 'discharged';
exports.DISCHARGED = DISCHARGED;
var CLOSED = 'closed'; // Interviews

exports.CLOSED = CLOSED;
var INTERVIEW_SESSION_INIT = 'interviewSessionInit';
exports.INTERVIEW_SESSION_INIT = INTERVIEW_SESSION_INIT;
var INTERVIEW_SESSION_STARTED = 'interviewSessionStarted';
exports.INTERVIEW_SESSION_STARTED = INTERVIEW_SESSION_STARTED;
var INTERVIEW_SESSION_PROGRESS = 'interviewSessionProgress';
exports.INTERVIEW_SESSION_PROGRESS = INTERVIEW_SESSION_PROGRESS;
var INTERVIEW_SESSION_ENDED = 'interviewSessionEnded'; // Operational

exports.INTERVIEW_SESSION_ENDED = INTERVIEW_SESSION_ENDED;
var ASSIGNED = 'assigned';
exports.ASSIGNED = ASSIGNED;
var REVIEW_STARTED = 'reviewStarted';
exports.REVIEW_STARTED = REVIEW_STARTED;
var REVIEW_FINISHED = 'reviewFinished';
exports.REVIEW_FINISHED = REVIEW_FINISHED;
var DEBTOR_EDITED = 'debtorEdited';
exports.DEBTOR_EDITED = DEBTOR_EDITED;
var ARCHIVED = 'archived';
exports.ARCHIVED = ARCHIVED;
var UNARCHIVED = 'unarchived';
exports.UNARCHIVED = UNARCHIVED;
var RESTARTED = 'restarted'; // DEPRECATE
// DEPRECATE
// DEPRECATE
// Docassemble Questionnaire Progression

exports.RESTARTED = RESTARTED;
var INTERVIEW_PROGRESS_ABOUT = 'interviewProgressAbout';
exports.INTERVIEW_PROGRESS_ABOUT = INTERVIEW_PROGRESS_ABOUT;
var INTERVIEW_PROGRESS_ASSETS = 'interviewProgressAssets';
exports.INTERVIEW_PROGRESS_ASSETS = INTERVIEW_PROGRESS_ASSETS;
var INTERVIEW_PROGRESS_INCOME = 'interviewProgressIncome';
exports.INTERVIEW_PROGRESS_INCOME = INTERVIEW_PROGRESS_INCOME;
var INTERVIEW_PROGRESS_EXPENSES = 'interviewProgressExpenses';
exports.INTERVIEW_PROGRESS_EXPENSES = INTERVIEW_PROGRESS_EXPENSES;
var INTERVIEW_PROGRESS_DEBTS = 'interviewProgressDebts';
exports.INTERVIEW_PROGRESS_DEBTS = INTERVIEW_PROGRESS_DEBTS;
var INTERVIEW_PROGRESS_OTHER = 'interviewProgressOther';
exports.INTERVIEW_PROGRESS_OTHER = INTERVIEW_PROGRESS_OTHER;
var INTERVIEW_PROGRESS_PREVIEW = 'interviewProgressPreview';
exports.INTERVIEW_PROGRESS_PREVIEW = INTERVIEW_PROGRESS_PREVIEW;
var INTERVIEW_PROGRESS_EDIT = 'interviewProgressEdit';
exports.INTERVIEW_PROGRESS_EDIT = INTERVIEW_PROGRESS_EDIT;
var INTERVIEW_PROGRESS_COMPLETE = 'interviewProgressComplete'; // - Means choices made that a person can't redeem themselves from

exports.INTERVIEW_PROGRESS_COMPLETE = INTERVIEW_PROGRESS_COMPLETE;
var INTERVIEW_DISQUALIFIED = 'interviewDisqualified'; // - Means changes can be made to avert a situation

exports.INTERVIEW_DISQUALIFIED = INTERVIEW_DISQUALIFIED;
var INTERVIEW_STOP = 'interviewStop';
exports.INTERVIEW_STOP = INTERVIEW_STOP;